import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { format, addDays, startOfWeek } from 'date-fns';

const { FiChevronLeft, FiChevronRight, FiFilter } = FiIcons;

// Mock calendar data
const EVENTS = [
  { id: 1, title: 'Dentist - Mia', type: 'health', date: new Date(), time: '10:00 AM', color: 'bg-green-100 text-green-800 border-green-200' },
  { id: 2, title: 'Soccer Game', type: 'sports', date: new Date(), time: '5:00 PM', color: 'bg-blue-100 text-blue-800 border-blue-200' },
  { id: 3, title: 'PTA Meeting', type: 'school', date: addDays(new Date(), 1), time: '7:00 PM', color: 'bg-purple-100 text-purple-800 border-purple-200' },
  { id: 4, title: 'Piano Lesson', type: 'activity', date: addDays(new Date(), 2), time: '4:00 PM', color: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
];

export default function CalendarView() {
  const today = new Date();
  const startDate = startOfWeek(today, { weekStartsOn: 1 }); // Start on Monday
  
  const weekDays = Array.from({ length: 7 }).map((_, i) => addDays(startDate, i));

  return (
    <div className="space-y-6 h-full flex flex-col">
      <header className="flex justify-between items-center bg-white p-4 rounded-2xl shadow-sm border border-slate-200">
        <div className="flex items-center gap-4">
          <h2 className="text-2xl font-bold text-[#1a365d]">
            {format(today, 'MMMM yyyy')}
          </h2>
          <div className="flex bg-slate-100 rounded-lg p-1">
            <button className="p-1.5 hover:bg-white rounded-md transition-colors"><SafeIcon icon={FiChevronLeft} /></button>
            <button className="px-3 text-sm font-medium hover:bg-white rounded-md transition-colors">Today</button>
            <button className="p-1.5 hover:bg-white rounded-md transition-colors"><SafeIcon icon={FiChevronRight} /></button>
          </div>
        </div>
        <button className="flex items-center gap-2 text-sm font-medium text-slate-600 bg-slate-100 px-3 py-2 rounded-lg hover:bg-slate-200">
          <SafeIcon icon={FiFilter} />
          Filter
        </button>
      </header>

      {/* Week View Grid */}
      <div className="flex-1 bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
        {/* Header Row */}
        <div className="grid grid-cols-7 border-b border-slate-200 bg-slate-50">
          {weekDays.map((day, i) => {
            const isToday = format(day, 'yyyy-MM-dd') === format(today, 'yyyy-MM-dd');
            return (
              <div key={i} className="p-3 text-center border-r border-slate-200 last:border-0">
                <div className="text-xs font-semibold text-slate-500 uppercase">{format(day, 'EEE')}</div>
                <div className={`mt-1 text-lg font-bold w-8 h-8 mx-auto flex items-center justify-center rounded-full ${
                  isToday ? 'bg-[#1a365d] text-yellow-300' : 'text-slate-800'
                }`}>
                  {format(day, 'd')}
                </div>
              </div>
            );
          })}
        </div>
        
        {/* Content Area (Simulated) */}
        <div className="flex-1 grid grid-cols-7 bg-slate-50/50">
          {weekDays.map((day, i) => {
             const dayEvents = EVENTS.filter(e => format(e.date, 'yyyy-MM-dd') === format(day, 'yyyy-MM-dd'));
             
             return (
              <div key={i} className="border-r border-slate-200 last:border-0 p-2 space-y-2 min-h-[400px]">
                {dayEvents.map(event => (
                  <div key={event.id} className={`p-2 rounded-lg text-xs font-medium border shadow-sm cursor-pointer hover:shadow-md transition-all ${event.color}`}>
                    <div className="font-bold mb-0.5">{event.time}</div>
                    <div className="truncate">{event.title}</div>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}